export default __webpack_public_path__ + "static/media/edificio-rimac2.aae7a65f.png";